module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "date-picker",
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "-20px",
      "width": "100px"
    }
  }, [_vm._v(_vm._s(_vm.currentText.from))]), _c('Flatpickr', {
    ref: "flatpickrfrom",
    attrs: {
      "options": _vm.fpOptions
    },
    model: {
      value: (_vm.currentFromDate),
      callback: function($$v) {
        _vm.currentFromDate = $$v
      },
      expression: "currentFromDate"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "-20px",
      "width": "100px"
    }
  }, [_vm._v(_vm._s(_vm.currentText.to))]), _c('Flatpickr', {
    ref: "flatpickrto",
    attrs: {
      "options": _vm.fpOptions
    },
    model: {
      value: (_vm.currentToDate),
      callback: function($$v) {
        _vm.currentToDate = $$v
      },
      expression: "currentToDate"
    }
  }), _vm._v(" "), (_vm.currentFromDate != _vm.today || _vm.currentToDate != _vm.aWeekFromNow) ? _c('img', {
    attrs: {
      "src": require("../assets/calendar.svg")
    },
    on: {
      "click": _vm.resetCurrentDate
    }
  }) : _vm._e()], 1), _vm._v(" "), _vm._l((_vm.dates), function(date) {
    return _c('div', {
      staticClass: "date"
    }, [_c('div', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(_vm.localizeDate(date)))]), _vm._v(" "), _vm._l((_vm.filter(_vm.getActivities(date))), function(activity) {
      return _c('div', {
        staticClass: "activity",
        class: {
          past: _vm.isPastActivity(activity), activeActivity: _vm.isActiveActivity(activity)
        },
        on: {
          "click": function($event) {
            _vm.toggleActive(activity)
          }
        }
      }, [_c('img', {
        attrs: {
          "src": activity.pic,
          "alt": "aktivitet"
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "content"
      }, [_c('div', {
        staticClass: "title"
      }, [_vm._v(_vm._s(activity.title.da))]), _vm._v(" "), _c('div', {
        staticStyle: {
          "font-size": "1.2em"
        }
      }, [_vm._v(_vm._s(_vm._f("minutesToTimeOfDay")(activity.startTimeInMinutes)) + " - " + _vm._s(_vm._f("minutesToTimeOfDay")(activity.endTimeInMinutes)))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(activity.about.da))]), _vm._v(" "), (_vm.isActiveActivity(activity)) ? [_c('div', {
        staticClass: "info"
      }, [_c('span', {
        staticClass: "heading"
      }, [_vm._v(_vm._s(_vm.currentText.time))]), _c('span', {
        staticClass: "text"
      }, [_vm._v(_vm._s(_vm.localizeDate(date)) + ", " + _vm._s(_vm._f("minutesToTimeOfDay")(activity.startTimeInMinutes)) + " - " + _vm._s(_vm._f("minutesToTimeOfDay")(activity.endTimeInMinutes)))])]), _vm._v(" "), _c('div', {
        staticClass: "info"
      }, [_c('span', {
        staticClass: "heading"
      }, [_vm._v(_vm._s(_vm.currentText.aktivitetfor))]), _c('span', {
        staticClass: "text"
      }, [(activity.who === 'adults') ? _c('span', [_vm._v(_vm._s(_vm.currentText.adults))]) : _vm._e(), (activity.who === 'family') ? _c('span', [_vm._v(_vm._s(_vm.currentText.family))]) : _vm._e(), (activity.who === 'children') ? _c('span', [_vm._v(_vm._s(_vm.currentText.children))]) : _vm._e()])]), _vm._v(" "), _c('div', {
        staticClass: "info"
      }, [_c('span', {
        staticClass: "heading"
      }, [_vm._v(_vm._s(_vm.currentText.info))]), _c('span', {
        staticClass: "text",
        staticStyle: {
          "white-space": "pre-wrap"
        }
      }, [_vm._v(_vm._s(activity.info.da))])]), _vm._v(" "), _c('div', {
        staticClass: "info"
      }, [_c('span', {
        staticClass: "heading"
      }, [_vm._v(_vm._s(_vm.currentText.location))]), _c('span', {
        staticClass: "text"
      }, [_vm._v(_vm._s(activity.location.da))])]), _vm._v(" "), _c('div', {
        staticClass: "info"
      }, [_c('span', {
        staticClass: "heading"
      }, [_vm._v(_vm._s(_vm.currentText.organiser))]), _c('span', {
        staticClass: "text"
      }, [_vm._v(_vm._s(activity.organiser))])]), _vm._v(" "), (activity.maxAmountOfParticipants) ? _c('div', {
        staticClass: "info"
      }, [_c('span', {
        staticClass: "heading"
      }, [_vm._v(_vm._s(_vm.currentText.maxParticipants))]), _c('span', {
        staticClass: "text"
      }, [_vm._v(_vm._s(activity.maxAmountOfParticipants) + " (" + _vm._s(_vm.currentText.maxParticipantsSignUp) + ")")])]) : _vm._e(), _vm._v(" "), (activity.price !== 0 || activity.priceCategory === 'freeForAll') ? _c('div', {
        staticClass: "info"
      }, [_c('span', {
        staticClass: "heading"
      }, [_vm._v(_vm._s(_vm.currentText.price))]), _vm._v(" "), _c('span', {
        staticClass: "text"
      }, [(activity.priceCategory !== 'freeForAll') ? _c('span', [_vm._v(_vm._s(activity.price) + " DKK\n                    "), (activity.priceCategory === 'freeWithPackage') ? _c('span', [_vm._v("(" + _vm._s(_vm.currentText.freeWithPackage) + ")")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (activity.priceCategory === 'freeForAll') ? _c('span', [_vm._v(_vm._s(_vm.currentText.free))]) : _vm._e()])]) : _vm._e()] : _vm._e()], 2), _vm._v(" "), _c('img', {
        staticClass: "arrow",
        staticStyle: {
          "position": "absolute",
          "bottom": "0",
          "right": "0",
          "width": "22px",
          "height": "22px",
          "user-select": "none"
        },
        attrs: {
          "src": require("../assets/arrowdown.svg")
        }
      })])
    })], 2)
  }), _vm._v(" "), (!_vm.dataLoaded) ? _c('div', {
    staticClass: "spinner"
  }) : _vm._e(), _vm._v(" "), ((_vm.dataLoaded && _vm.dates && _vm.dates.length === 0 && _vm.currentFromDate !== '' && _vm.currentToDate !== '') || (_vm.currentFromDate === '' && _vm.currentToDate === '' && _vm.dataLoaded && _vm.dates.length === 0)) ? _c('div', [_vm._v(_vm._s(_vm.currentText.noActivities))]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a5eaf8d4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Calendar.vue
// module id = 199
// module chunks = 1